import React, { useState, useEffect } from 'react';
// Common Components
import AppBreadCrumb from '../../common/AppBreadCrumb';
import AppToaster from '../../AppToaster';
// API & Utils
import { getStockView } from '../../../api/StockAPI'; // Using the new StockAPI.js
import { handleApiError } from '../../../api/risapi';

const StockView = () => {
    const [stockData, setStockData] = useState([]);
    const [viewDataLoading, setViewDataLoading] = useState(true);
    const [showToaster, setShowToaster] = useState(false);
    const [toaster, setToaster] = useState({});

    useEffect(() => {
        document.title = 'Current Stock View';
        setViewDataLoading(true);

        // Using the callback pattern from your API files
        getStockView((response) => {
            setViewDataLoading(false);
            if (response.stock_view) {
                setStockData(response.stock_view);
            } else {
                // Use the handleApiError helper
                handleApiError(response);
                setToaster({ type: 'danger', heading: 'Error', message: 'Could not load stock view.' });
                setShowToaster(true);
                setStockData([]);
            }
        });
    }, []); // Run once on mount

    const renderStockTable = () => {
        if (viewDataLoading) {
            return (
                <tr>
                    <td colSpan="4" className="text-center">
                        <div className="loader_box"><div className="loader_14"></div></div>
                    </td>
                </tr>
            );
        }

        if (stockData.length === 0) {
            return (
                <tr>
                    <td colSpan="4" className="text-center text-muted">
                        No stock movements found.
                    </td>
                </tr>
            );
        }

        // Using React.Fragment to group rows per product
        return stockData.map((product) => (
            <React.Fragment key={product.id}>
                {product.stock_levels.map((level, index) => (
                    <tr key={`${product.id}-${level.uom_name}`}
                        // Style to group rows belonging to the same product
                        style={{ borderTop: index > 0 ? '1px solid #e9ecef' : 'none' }}
                    >
                        {/* Product Name (only on the first row) */}
                        <td style={{ verticalAlign: 'middle' }}>
                            {index === 0 && <strong className="f-w-600">{product.name}</strong>}
                        </td>
                        
                        {/* UOM Name */}
                        <td style={{ paddingLeft: '2rem' }}>{level.uom_name}</td>
                        
                        {/* Available Stock */}
                        <td className={`text-end f-w-600 ${level.available >= 0 ? 'text-success' : 'text-danger'}`}>
                            {level.available}
                        </td>
                        
                        {/* Pending Outgoing */}
                        <td className={`text-end ${level.pending_out < 0 ? 'text-danger' : 'text-muted'}`}>
                            {level.pending_out}
                        </td>
                    </tr>
                ))}
                {/* Thick border to separate products */}
                <tr style={{ borderBottom: '2px solid #adb5bd' }}>
                    <td colSpan="4" className="p-0"></td> 
                </tr>
            </React.Fragment>
        ));
    };

    return (
        <>
            <AppToaster showToaster={showToaster} setShowToaster={setShowToaster} toaster={toaster} />
            <main>
                <div className="container-fluid">
                    <AppBreadCrumb title='Current Stock View'>
                        <li><a className="f-s-14 f-w-500" href="#">Inventory</a></li>
                        <li className="active"><a className="f-s-14 f-w-500" href="#">Stock View</a></li>
                    </AppBreadCrumb>

                    <div className="row">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-header d-flex justify-content-between align-items-center">
                                    <h5 className="mb-0">Current Stock by Product and UOM</h5>
                                    {/* Optional: Add a refresh button */}
                                    <button 
                                        className="btn btn-red btn-sm" 
                                        onClick={() => setViewDataLoading(true)} 
                                        disabled={viewDataLoading}
                                    >
                                        {viewDataLoading ? 'Loading...' : <i className="ti ti-reload"></i>}
                                    </button>
                                </div>
                                <div className="card-body p-0">
                                    <div className="table-responsive">
                                        <table className="table table-hover table-striped mb-0" style={{ tableLayout: 'fixed' }}>
                                            <thead className="table-light">
                                                <tr>
                                                    <th style={{ width: '40%' }}>Product</th>
                                                    <th style={{ width: '20%' }}>Unit of Measure</th>
                                                    <th className="text-end" style={{ width: '20%' }}>Available Stock</th>
                                                    <th className="text-end" style={{ width: '20%' }}>Pending Outgoing</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {renderStockTable()}
                                            </tbody>
                                        </table>
                                    </div>
                                </div> {/* card-body */}
                            </div> {/* card */}
                        </div> {/* col */}
                    </div> {/* row */}
                </div> {/* container-fluid */}
            </main>
        </>
    );
};

export default StockView;